import { default as folderValidationSchema } from '@/components/dialogs/AddFolderSharepointDialog/validationSchema';
import * as Yup from 'yup';
import {
	CLIENT_ID,
	DEAL_NAME,
	FILES,
	YEAR_FOLDER,
} from '../CreateNewBusinessForm/validationSchema';

export const validationSchema = Yup.object()
	.shape({
		[CLIENT_ID]: Yup.string().required('Client is required.'),
		// [DEAL_NAME]: Yup.string().required('Deal name is required.'),
		[FILES]: Yup.array(),
		notes: Yup.string(),
		[YEAR_FOLDER]: Yup.string().nullable().required('Year folder is required.'),
		transactions: Yup.array().min(1, 'At least one policy transaction is required').ensure(),
	})
	.concat(folderValidationSchema([], 'Debtor name'));
